export default __webpack_public_path__ + "static/media/1976.5e031078.png";